module.exports = __webpack_public_path__ + "img/tokelau.18169e46.svg";